import { Component, OnInit } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'
import { SearchBoxAlphaComponent } from '../../molecule/search-box-alpha/search-box-alpha.component'
import { GameCardAlphaComponent } from '../../molecule/game-card-alpha/game-card-alpha.component'
import { SearchResult } from '../../gql/generated'
import { SidebarComponent } from '../../molecule/sidebar/sidebar.component'
import { GameCardBetaComponent } from '../../molecule/game-card-beta/game-card-beta.component'
import { SearchService } from '../../service/search.service'
import { GameCardGammaComponent } from '../../molecule/game-card-gamma/game-card-gamma.component'
import { GameAdBetaComponent } from '../../molecule/game-ad-beta/game-ad-beta.component'
import { GameAdAlphaComponent } from '../../molecule/game-ad-alpha/game-ad-alpha.component'

@Component({
  selector: 'app-design-system',
  templateUrl: './design-system.component.html',
  styleUrl: './design-system.component.less',
  standalone: true,
  imports: [
    AtomModule,
    SearchBoxAlphaComponent,
    GameCardAlphaComponent,
    GameCardBetaComponent,
    SidebarComponent,
    GameCardGammaComponent,
    GameAdBetaComponent,
    GameAdAlphaComponent
  ],
})
export class DesignSystemComponent implements OnInit {
  data: SearchResult
  constructor(private searchService: SearchService) {}

  ngOnInit() {
    this.searchService.search('astro').subscribe({
      next: (result) => {
        this.data = result.data.search.items[0] as SearchResult;
      }
    });

  }
}
